import { Trash2, TriangleAlert } from 'lucide-react';
import { Spinner, cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';
import type { HandoverPhotoDraft } from '../model/handover.store.js';

/**
 * Olingan suratlarning ESKIZLARI — yuklanish holati bilan.
 *
 * Holat rasmning O'ZIDA ko'rsatiladi, alohida ro'yxatda emas: uchta rasmdan
 * qaysi biri yuklanmaganini bilish uchun odam ro'yxat bilan eskizlarni
 * solishtirishi kerak bo'lardi. Yiqilgan rasm qizil belgi bilan turadi va
 * uni o'chirib, qaytadan olish mumkin.
 */
export interface PhotoGridProps {
  photos: readonly HandoverPhotoDraft[];
  onRemove: (id: string) => void;
}

export const PhotoGrid = ({ photos, onRemove }: PhotoGridProps) => {
  if (photos.length === 0) return null;

  return (
    <ul
      // Telefonda uchta ustun (qo'lqopdagi barmoq uchun yetarli katta),
      // katta ekranda esa ko'proq: rasm ustun kengligiga cho'zilib,
      // yarim ekranni egallab qolmasligi kerak.
      className="grid grid-cols-3 gap-3 md:grid-cols-5 xl:grid-cols-6"
    >
      {photos.map((photo) => (
        <li
          key={photo.id}
          className={cn(
            'relative overflow-hidden rounded-[var(--radius-md)]',
            'border border-border bg-surface-2',
          )}
        >
          {/* Manba MAHALLIY (`blob:`) — surat hali serverga yetib bormagan
              bo'lishi ham mumkin va uni kutish shart emas. */}
          <img
            src={photo.previewUrl}
            alt={photo.name}
            className="aspect-square w-full object-cover"
          />

          {photo.status === 'ready' ? null : (
            <span
              className={cn(
                'absolute inset-0 flex flex-col items-center justify-center gap-1',
                'bg-bg/70 text-xs font-medium',
                photo.status === 'failed' ? 'text-danger' : 'text-text-muted',
              )}
            >
              {photo.status === 'failed' ? (
                <TriangleAlert size={16} aria-hidden />
              ) : (
                <Spinner size="sm" />
              )}
              {t(photo.status === 'failed' ? 'handover.photoFailed' : 'handover.photoUploading')}
            </span>
          )}

          <button
            type="button"
            aria-label={t('handover.photoRemove')}
            onClick={() => onRemove(photo.id)}
            className={cn(
              'absolute top-1.5 right-1.5 flex size-8 items-center justify-center',
              'rounded-[var(--radius-pill)] border border-border bg-surface',
              'text-text-muted hover:border-danger hover:text-danger',
            )}
          >
            <Trash2 size={14} aria-hidden />
          </button>
        </li>
      ))}
    </ul>
  );
};
